"use client";
import { HouseIcon } from "@phosphor-icons/react/dist/csr/House";
import { ChartBarIcon } from "@phosphor-icons/react/dist/csr/ChartBar";
import { GearSixIcon } from "@phosphor-icons/react/dist/csr/GearSix";
import { BottomNav as SharedBottomNav } from "@hicya/ui";

import type { BottomNavItem } from "@hicya/ui";

const ITEMS: BottomNavItem[] = [
  { to: "/today", label: "Today", icon: <HouseIcon size={24} /> },
  { to: "/stats", label: "Stats", icon: <ChartBarIcon size={24} /> },
  { to: "/settings", label: "Settings", icon: <GearSixIcon size={24} /> },
];

export function BottomNav() {
  return <SharedBottomNav items={ITEMS} />;
}
